import { render, staticRenderFns } from "./ArrowRightLongLight.vue?vue&type=template&id=57850a6d"
import script from "./ArrowRightLongLight.vue?vue&type=script&lang=ts"
export * from "./ArrowRightLongLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports